export const RQ_RECORDING_KEY = ['recording'];
export const RQ_RECORDINGS_KEY = ['recordings'];
export const RECORDING_PAGE_SIZE = 20;
export const RECORDING_FIRST_DETAIL_SCREEN_VIEWED_STORAGE_KEY = 'recordingFirstDetailScreenViewed';
